import { Container, Text } from '@mantine/core';
import classes from './Footer.module.css';

export function Footer(): JSX.Element {
  // Access the HOSTNAME environment variable directly
  const hostname = import.meta.env.HOSTNAME || 'localhost';
  
  return (
    <footer className={classes.footer}>
      <div className={classes.inner}>
        <Container p="xl">
          <Text c="dimmed" size="sm">
            &copy; {new Date().getFullYear()} Copilot Health. | {hostname}
          </Text>
        </Container>
      </div>
    </footer>
  );
}
